/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, color, centerAbsolutely, mediaQuery } from 'utils/styles';
import { aniFrameRewardOnlyInitial } from 'components/content/shared/questionset/shared/animations/frame_rewardonly/initial';
import { aniFrameRewardOnlyResult } from 'components/content/shared/questionset/shared/animations/frame_rewardonly/result';
import { aniRewardOnlyInitial } from 'components/content/shared/questionset/shared/animations/rewardonly/initial';
import { aniRewardOnlyResult } from 'components/content/shared/questionset/shared/animations/rewardonly/result';
import { aniQuestionInitial } from 'components/content/shared/questionset/shared/animations/question/initial';
import { aniQuestionResult } from 'components/content/shared/questionset/shared/animations/question/result';
import { aniQuestionRewardOnlyResult } from 'components/content/shared/questionset/shared/animations/question/result_rewardonly';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// INPUT QUESTION TYPE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    resultelements: {},
    answerset: {},
    typeset: {
        width: '100%',
        height: '100%',

        // ------ QUESTION ----- //
        '& .question': {
            transform: 'translate3d(-100%, 0, 0)', // pull off screen to start
            animationName: 'slideInLeft',
            animationDelay: '.1s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },

        // ------ ANSWER SET ----- //
        '& .answerset': {
            marginTop: pxToEm(15),
            transform: 'translateX(-200%)',
            opacity: '0'
        },
        
        // !!!!!!!!!!!!!!!!!!! ~~~~~~~~~~~~~~~~~~~~~~~ ANIMATIONS ~~~~~~~~~~~~~~~~~~~~~~~ !!!!!!!!!!!!!!!!!!! //
        extend: [aniRewardOnlyInitial, centerAbsolutely],
        // *** INITIAL STATE *** //
        '&.initial': {
            extend: [aniFrameRewardOnlyInitial, aniQuestionInitial],
            '& .answerset': {
                animationName: 'fadeInLeft',
                animationDelay: '.3s',
                animationDuration: '.3s',
                animationFillMode: 'forwards',
                '& .field.button-true .button': {
                    opacity: '0',
                    animationName: 'fadeInLeft',
                    animationDelay: '.4s',
                    animationDuration: '.3s',
                    animationFillMode: 'forwards'
                }
            }
        },
        // *** RESULT STATE *** //
        '&.result': {
            extend: [aniFrameRewardOnlyResult, aniRewardOnlyResult, aniQuestionRewardOnlyResult],
            '& .answerset': {
                transform: 'none',
                opacity: '1'
            }
        },
        // *** REWARDS STATE *** //
        '&.rewards': {
            '& .answerset, .resultelements, .question': {
                // removes text when shrinking the images
                display: 'none'
            },
            '& .rewardsmessage': { // This class name is in RewardsMessage component! It's a RewardsMessage wrapper div.
                display: 'block',
                width: '100%',
                height: '100%',
                opacity: '0', // pull off screen to start
                animationName: 'fadeIn',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards'
            }
        },


        // ***** REMOVE ANIMATIONS IF QUESTIONNAIRE ***** //
        '&.parentContentType-questionnaire': {
            // '& .question': {
            //     transform: 'none !important',
            //     animationName: 'none !important',
            //     opacity: '1 !important'
            // },
            // '& .answerset': {
            //     transform: 'none !important',
            //     animationName: 'none !important',
            //     opacity: '1 !important',
            //     '& .field.button-true .button': {
            //         transform: 'none !important',
            //         animationName: 'none !important',
            //         opacity: '1 !important',
            //     }
            // }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        
    },
    [mediaQuery.thin]: {
        
    }
};
